/*
 * 首页「Not sure about your window?」（sections/home-window-help.liquid）。
 * 1. 上传弹窗：原生 <dialog>.showModal() —— 顶层渲染（压过客服气泡、翻译挂件这些第三方浮层）、
 *    背景自动 inert、Esc 关闭都是浏览器自带的。这里补：滚动锁、点遮罩关闭、关闭后焦点回到触发按钮。
 *    打开时把焦点放在弹窗卡片本身而不是第一个输入框，手机上不会一打开就弹键盘挡住说明文字。
 *    链接带 #free-mockup 时进页面自动打开，方便运营在邮件 / 社媒里直接投放这个入口。
 * 2. Chat with us：唤起 Zendesk（和 model-item 相同：zE 由 App 注入、时机不定，轮询等 6 秒，等不到走链接）。
 */
(function () {
  var HASH = '#free-mockup';

  function lockScroll(lock) {
    document.documentElement.classList.toggle('hwh-scroll-lock', lock);
  }

  // 卡片视频（后台选了视频时代替图片）：纯装饰，读屏忽略；偏好减少动态效果时不自动播放，停在封面帧
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function syncVideo(video) {
    video.muted = true;
    if (reduceMotion && reduceMotion.matches) {
      video.removeAttribute('autoplay');
      video.pause();
    } else if (video.paused) {
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    }
  }

  function init(root) {
    if (!root || root.dataset.hwhReady) return;
    root.dataset.hwhReady = 'true';

    var videos = root.querySelectorAll('.hwh__media video');
    videos.forEach(function (video) {
      video.setAttribute('aria-hidden', 'true');
      video.setAttribute('tabindex', '-1');
      syncVideo(video);
    });
    if (videos.length && reduceMotion) {
      var onMotionChange = function () { videos.forEach(syncVideo); };
      if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', onMotionChange);
      else if (reduceMotion.addListener) reduceMotion.addListener(onMotionChange);
    }

    var dialog = root.querySelector('[data-hwh-dialog]');
    var lastTrigger = null;
    // iOS Safari 弹软键盘时不理会 overflow:hidden，会把后面的页面推下去一截；关弹窗时回到打开前的位置
    var lockedScrollY = null;

    // 用 open 属性而不是 dialog.open：不支持 <dialog> 的旧浏览器上 .open 是 undefined，关不掉
    function isOpen() {
      return !!dialog && dialog.hasAttribute('open');
    }

    function open(trigger) {
      if (!dialog || isOpen()) return;
      lastTrigger = trigger || null;
      lockedScrollY = window.scrollY;
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      lockScroll(true);
      var card = dialog.querySelector('[data-hwh-dialog-card]');
      if (card) card.focus({ preventScroll: true });
    }

    // 收尾（解滚动锁、焦点回到触发按钮）可重入：我们自己关时直接调，
    // 浏览器自己关（原生 Esc）时由 close 事件再调一次也没关系。
    // 不能只靠 close 事件 —— 实测有的 Chromium 版本 dialog.close() 之后 close 事件不触发，滚动锁就一直挂着。
    function cleanup() {
      lockScroll(false);
      if (lockedScrollY !== null && Math.abs(window.scrollY - lockedScrollY) > 1) {
        window.scrollTo({ top: lockedScrollY, left: window.scrollX, behavior: 'instant' });
      }
      lockedScrollY = null;
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
      lastTrigger = null;
    }

    function close() {
      if (!dialog) return;
      if (isOpen()) {
        if (typeof dialog.close === 'function') dialog.close();
        if (isOpen()) dialog.removeAttribute('open');
      }
      cleanup();
    }

    if (dialog) {
      dialog.addEventListener('close', cleanup);
      dialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        close();
      });

      // 点到卡片外面（<dialog> 自身就是全屏遮罩那一层）才关；在卡片里拖选文字松手落到外面不算
      var downOnBackdrop = false;
      dialog.addEventListener('pointerdown', function (event) {
        downOnBackdrop = event.target === dialog;
      });
      dialog.addEventListener('click', function (event) {
        if (downOnBackdrop && event.target === dialog) close();
        downOnBackdrop = false;
      });

      // 原生 <dialog> 的 Esc 关闭会被页面上别的 keydown 监听 preventDefault 掉（实测主题里就有），自己兜一层
      dialog.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        close();
      });

      dialog.querySelectorAll('[data-hwh-close]').forEach(function (button) {
        button.addEventListener('click', close);
      });
    }

    root.querySelectorAll('[data-hwh-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        if (!dialog) return;
        event.preventDefault();
        open(trigger);
      });
    });

    root.querySelectorAll('[data-hwh-chat]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        // ctrl / cmd / shift / 中键保持“新标签页打开链接”
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
        var href = link.getAttribute('href');
        event.preventDefault();
        var tries = 0;
        (function wait() {
          if (typeof window.zE === 'function') {
            window.zE(function () {
              window.zE('messenger', 'open');
            });
            return;
          }
          if (tries++ < 24) {
            setTimeout(wait, 250);
          } else if (href) {
            window.location.href = href;
          }
        })();
      });
    });

    if (dialog && window.location.hash === HASH) {
      var firstTrigger = root.querySelector('[data-hwh-open]');
      root.scrollIntoView({ block: 'start' });
      open(firstTrigger);
    }

    root.hwhOpen = open;
    root.hwhClose = close;
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-hwh]').forEach(init);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  // Theme Editor 里选中表单 App block 时把弹窗打开，方便运营看效果
  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest && event.target.closest('[data-hwh]');
    if (root && root.hwhOpen && event.target.closest('[data-hwh-dialog]')) root.hwhOpen();
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.querySelector && event.target.querySelector('[data-hwh]')) lockScroll(false);
  });
})();
